interface Props {
    glassColor: string,
    sandColor: string,
    width: string,
    height: string
}


export default function HourGlassRoundedTwoTonedBottom({glassColor,sandColor, width, height} : Props) {
    return (
        <svg
            height={height}
            viewBox="0 0 12 20"
            width={width}
            fill={glassColor}
            version="1.1"
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs
                id="defs2" />
            <path
                d="M 2,20 C 0.9,20 0,19.1 0,18 V 14.83 C 0,14.3 0.21,13.79 0.59,13.41 L 4,10 0.58,6.58 C 0.21,6.2 0,5.69 0,5.16 V 2 C 0,0.9 0.9,0 2,0 h 8 c 1.1,0 2,0.9 2,2 V 5.16 C 12,5.69 11.79,6.2 11.42,6.57 L 8,10 11.41,13.4 C 11.79,13.78 12,14.29 12,14.82 V 18 c 0,1.1 -0.9,2 -2,2 z M 10,5.5 V 3 C 10,2.45 9.55,2 9,2 H 3 C 2.45,2 2,2.45 2,3 v 2.5 l 4,4 z m -4,5 -4,4 V 17 c 0,0.55 0.45,1 1,1 h 6 c 0.55,0 1,-0.45 1,-1 v -2.5 z"
                id="path2" />
            <path
                style={{ fill: sandColor, strokeWidth: 0.0211125 }}
                d="M 3.9535404,12.4916 1.907455,14.530757 v 1.328598 c 0,1.125009 0.00496,1.347583 0.032383,1.452497 0.092943,0.355608 0.3616686,0.633158 0.7183924,0.741983 0.1207638,0.03684 0.2826393,0.03871 3.3520526,0.03871 h 3.225161 l 0.14804,-0.04698 c 0.08143,-0.02584 0.184776,-0.06939 0.229675,-0.09678 0.128355,-0.07829 0.299537,-0.2594 0.37038,-0.391863 0.129941,-0.242957 0.129571,-0.238123 0.129571,-1.697649 v -1.32868 L 8.066944,12.491517 C 6.941551,11.370026 6.016017,10.452441 6.010201,10.452441 c -0.0059,0 -0.931312,0.917621 -2.0566606,2.039159 z"
                id="path3" />
        </svg>


    )
}
